import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/react/react/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { HeroLayout } from '@primer/gatsby-theme-doctocat';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = HeroLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Primer React`}</h2>
    <p>{`Primer React is a React implementation of GitHub's `}<a parentName="p" {...{
        "href": "https://primer.style/"
      }}>{`Primer Design System`}</a>{` 🎉`}</p>
    <h2>{`Principles`}</h2>
    <ul>
      <li parentName="ul">{`Everything is a component.`}</li>
      <li parentName="ul">{`Aim for total style encapsulation; don't rely on inheritance to provide default styles.`}</li>
      <li parentName="ul">{`Build small building blocks with minimal props to keep complexity low.`}</li>
      <li parentName="ul">{`Keep system constrained by only including props needed per component.`}</li>
      <li parentName="ul">{`Favor wrapping or extending components for more complex operations.`}</li>
      <li parentName="ul">{`Maintain design system consistency with utilities as props (for spacing, color, font-size, line-height, widths, and radii).`}</li>
    </ul>
    <h2>{`Getting started`}</h2>
    <p>{`Check out `}<a parentName="p" {...{
        "href": "/react/getting-started"
      }}>{`our getting started guide`}</a>{` for everything you need to know about installing and using Primer React.`}</p>
    <h2>{`Local development`}</h2>
    <p>{`To run `}<inlineCode parentName="p">{`@primer/react`}</inlineCode>{` locally when adding or updating components:`}</p>
    <ol>
      <li parentName="ol">{`Clone this repo: `}<inlineCode parentName="li">{`git clone https://github.com/primer/react`}</inlineCode></li>
      <li parentName="ol">{`Install dependencies: `}<inlineCode parentName="li">{`npm install`}</inlineCode></li>
      <li parentName="ol">{`Run the dev app: `}<inlineCode parentName="li">{`npm start`}</inlineCode></li>
    </ol>
    <blockquote>
      <p parentName="blockquote">{`👉 See `}<a parentName="p" {...{
          "href": "https://github.com/primer/react/blob/main/contributor-docs/CONTRIBUTING.md"
        }}>{`the contributing docs`}</a>{` for more info on code style, testing, and coverage.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      